import { useReduxState } from 'hooks';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesQuickLinks
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleQuickLinks = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  return (
    <div>
      <HomePageSettingsTilesQuickLinks
        module={module}
        updateModule={updateModule}
      />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.homePageModuleQuickLinksTitle,
            value: module.data?.links?.length || 0
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          hideLimit={true}
          module={module}
          onUpdate={updateModule}
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleQuickLinks;
